const logStatusLookup: {
  [key: string]: "completed" | "inProgress";
} = {
  Completed: "completed",
  InProgress: "inProgress",
};

const logStatusColorLookup: {
  [key: string]: "success" | "warning";
} = {
  Completed: "success",
  InProgress: "warning",
};

export const logStatusToName = (status: string) => {
  return logStatusLookup[status];
};

export const logStatusToColor = (status: string) => {
  return logStatusColorLookup[status];
};
